import { MetaProps } from '../../../../types/IHeader';
import { CollectionPage } from 'schema-dts';
import { siteUrl } from '..';

export const collectionPage = (
  data: MetaProps,
  uri: string,
  localeSlug: string,
): CollectionPage => {
  return {
    '@id': `${siteUrl}${uri}`,
    '@type': 'CollectionPage',
    url: `${siteUrl}${uri}`,
    name: data?.metaFields?.title,
    primaryImageOfPage: data?.metaFields?.image && {
      '@id': `${siteUrl}${uri}#primaryimage`,
    },
    image: data?.metaFields?.image && {
      '@id': `${siteUrl}${uri}#primaryimage`,
    },
    thumbnailUrl: data?.metaFields?.image && data?.metaFields?.image?.url,
    isPartOf: {
      '@id': `${siteUrl}/${localeSlug}#website`,
    },
    description: data?.metaFields?.description,
    breadcrumb: {
      '@id': `${siteUrl}${uri}#breadcrumb`,
    },
  };
};
